import api from "../../services/api";

const useTokenApiMaster = () => {
  const get = async () => {
    const { data } = await api.request({
      url: "/token-api-master",
      method: "GET"
    });
    return data;
  };

  const generate = async () => {
    const { data } = await api.request({
      url: "/token-api-master/generate",
      method: "POST"
    });
    return data;
  };

  const revoke = async () => {
    const { data } = await api.request({
      url: "/token-api-master",
      method: "DELETE"
    });
    return data;
  };

  return {
    get,
    generate,
    revoke
  };
};

export default useTokenApiMaster;
